import React from 'react';
import { useIntl } from 'react-intl';

const SearchResultsHeader = ({
  pageTotal,
  totalRecords,
  resultsLength,
  className,
  isLoading,
}) => {
  // eslint-disable-next-line no-unused-vars
  const totalStr = totalRecords
    .toLocaleString()
    // for IE10
    .replace(/\D\d\d$/, '');
  const intl = useIntl();
  return (
    <div className={className}>
      <span>
        {isLoading &&
          intl.formatMessage({
            id: 'search.SearchResults.ResultsHeader.Loading',
          })}
        {!isLoading && (
          <React.Fragment>
            {pageTotal === totalRecords &&
              resultsLength === 1 &&
              intl.formatMessage(
                {
                  id: 'search.SearchResults.ResultsHeader.SinglePage',
                },
                {
                  totalRecords,
                },
              )}
            {pageTotal === totalRecords &&
              resultsLength > 1 &&
              intl.formatMessage(
                {
                  id: 'search.SearchResults.ResultsHeader.SinglePage',
                },
                {
                  totalRecords,
                },
              )}
            {pageTotal !== totalRecords &&
              pageTotal <= totalRecords &&
              intl.formatMessage(
                {
                  id: 'search.SearchResults.ResultsHeader.Pages',
                },
                {
                  pageTotal,
                  totalRecords,
                },
              )}
            {/* use case: no more results and pageTotal > totalRecords because first page is 1 */}
            {pageTotal !== totalRecords &&
              pageTotal > totalRecords &&
              intl.formatMessage(
                {
                  id: 'search.SearchResults.ResultsHeader.Pages',
                },
                {
                  pageTotal: totalRecords,
                  totalRecords,
                },
              )}
            &nbsp;
          </React.Fragment>
        )}
      </span>
    </div>
  );
};
export default SearchResultsHeader;



// WEBPACK FOOTER //
// ./src/views/components/Search/SearchResultsHeader.jsx